function handleKeyboardActivation(handler) {
    return e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            return handler();
        }
    };
}

export {
    handleKeyboardActivation
};
